/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteKalendereintraegeForMitarbeiter$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;

/**
 * Datum ab dem Kalendereinträge zurückgegeben werden sollen. (Inklusive)
 */
  From: string;

/**
 * Datum bis wann Kalendereinträge zurückgegeben werden sollen. (Inklusive)
 */
  To: string;
  IncludeInactiveMitarbeiter?: boolean;
}

export function deleteKalendereintraegeForMitarbeiter(http: HttpClient, rootUrl: string, params: DeleteKalendereintraegeForMitarbeiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteKalendereintraegeForMitarbeiter.PATH, 'delete');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('From', params.From, {});
    rb.query('To', params.To, {});
    rb.query('IncludeInactiveMitarbeiter', params.IncludeInactiveMitarbeiter, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteKalendereintraegeForMitarbeiter.PATH = '/v1/mitarbeiter/{mitarbeiterId}/kalendereintraege';
